import {Injectable} from '@angular/core';
import {AuthApiService} from '@npck/af-frontend-api';
import {AuthHolderService} from './auth-holder.service';

@Injectable({
    providedIn: 'root',
})
export class LogoutService {

    constructor(
        private authHolderService: AuthHolderService,
        private authApiService: AuthApiService,
    ) {
    }

    logout(reason?: string): void {
        if (!this.authHolderService.isRefreshTokenExpired()) {
            this.authApiService.logout(this.authHolderService.authResponse.refresh_token)
                .subscribe(() => this.authHolderService.logout(reason));
        } else {
            this.authHolderService.logout(reason);
        }
    }
}
